export const POPULATE_POKEMON_SELECTOR = "POPULATE_POKEMON_SELECTOR";
export const DISPLAY_SIZE_IS_LARGE = "DISPLAY_SIZE_IS_LARGE";
export const DISPLAY_SIZE_NOT_LARGE = "DISPLAY_SIZE_NOT_LARGE";
export const SET_POKEMON = "SET_POKEMON";
export const SET_EGG_GROUPS = "SET_EGG_GROUPS";
export const UPDATE_SEARCHFIELD = "UPDATE_SEARCHFIELD";
export const UPDATE_FILTERFIELD = "UPDATE_FILTERFIELD";
